import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ButtonClose from 'utils/buttons/ButtonClose';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import axios from 'axios';
import ButtonSendReport from 'utils/buttons/ButtonSendReport';
import messageHandler from 'utils/messageHandler';

const ReportModal = ({ propToReport, setPropToReport }) => {
  const userLogged = useSelector(state => state.login.currentUser);
  const { realEstate } = useSelector(state => state.realEstate);
  const [value, setValue] = useState('');

  const sendReport = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_SERVER}/denuncia/create`, {
        motivo: value,
        usuarioDenunciante: userLogged.id,
        realEstateDenunciante: realEstate.id,
        realEstateDenunciada: propToReport.real_estate.id,
        propertyId: propToReport.id
      });
      messageHandler('success', 'Su denuncia está siendo procesada.');
      setPropToReport(null);
    } catch {
      messageHandler(
        'error',
        'Ha ocurrido un error. Por favor, inténtelo de nuevo.'
      );
    }
  };

  return (
    <Modal show={!!propToReport} onHide={() => setPropToReport(null)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Denunciar publicación</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>{`El matriculado ${userLogged.firstName} ${userLogged.lastName} desea denunciar la publicación '${propToReport.title}' correspondiente a la inmobiliaria '${propToReport.real_estate?.name}.' `}</Form.Label>
          <Form.Label className="mt-3">
            Motivo de la denuncia <span className="text-danger">*</span>
          </Form.Label>
          <textarea
            className="form-control"
            value={value}
            onChange={e => setValue(e.target.value)}
            style={{ minHeight: 100, maxHeight: 250 }}
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <ButtonClose
          funcion={() => {
            setPropToReport(null);
          }}
          text="Cancelar"
          variant="secondary"
        />

        <ButtonSendReport
          text="Enviar denuncia"
          funcion={sendReport}
          disabled={!value}
        />
      </Modal.Footer>
    </Modal>
  );
};

ReportModal.propTypes = {
  propToReport: PropTypes.object,
  setPropToReport: PropTypes.func.isRequired
};

export default ReportModal;
